<template>
  <HXContentCard title="Lista de Personas">
    <div class="text-right px-4 mt-3">
      <button v-if="isCDCAuditor" v-b-tooltip.hover title="Gestión cuentas de cobros" class="mx-1 btn btn-success"
        @click="$router.push({ name: 'AuditoriaCuentaCobro' })">
        <i class="fas fa-file-circle-check"></i>
        Gestión CDC
      </button>
      <button class="mx-1 btn btn-primary" @click="$router.push({ name: 'Persona_agregar' })" id="agregarPersona">
        <i class="fas fa-plus-circle"></i>
        Agregar Persona
      </button>
      <button class=" btn btn-success" @click="$router.push({ name: 'Persona_cargaMasiva' })" id="cargaMasivaPersona">
        <i class="fa-solid fa-file-excel"></i>
        Carga Masiva
      </button>
      <button id="startButton" class="btn btn-danger mx-1" @click="startTour">
        <i class="far fa-circle-play mr-1"></i>
        Tutorial Rápido
      </button>
      <!-- tour guide -->
      <TourGuideLineal ref="tourGuide" />
    </div>
    <div class="px-5 py-3" id="estatsPersonas">
      <CardTable :data="dataCards" />
    </div>
    <div class="table-responsive px-4 mt-3">
      <div class="row">
        <div class="col-12 col-md-3 pb-3" v-if="persona.rol.nivel === 4">
          <label for="Nombre">Empresa *</label>
          <b-form-select name="Impuesto" v-model="EmpresaSeleccionada" :options="EmpresasLista" :value-field="'ID'"
            :text-field="'Nombre'" @change="handleCambioEmpresa" required>
            <template #selected="{ option }">
              {{ option?.Impuesto || "-- Seleccionar una empresa --" }}
            </template>
            <template #first>
              <b-form-select-option :value="null">-- Seleccionar una empresa --</b-form-select-option>
            </template>
          </b-form-select>
        </div>
        <div class="col-12 col-md-3 pb-3" v-if="persona.rol.nivel === 4">
          <label for="Nombre">Tipo de autenticación *</label>
          <b-form-select :disabled="!EmpresaSeleccionada" name="tipoAuth" v-model="tipoAuthSelected"
            :options="tiposAutenticacion" :value-field="'id'" :text-field="'text'" @change="actualizarTipoAutenticacion"
            required>
            <template #selected="{ option }">
              {{ option?.tipoAuth || "-- Seleccionar tipo --" }}
            </template>
            <template #first>
              <b-form-select-option :value="null">-- Seleccionar tipo --</b-form-select-option>
            </template>
          </b-form-select>
        </div>
      </div>
      <DataTableLotes ref="dataTableLotes" :fetch-data="fetchData" :columns="columns" :busqueda-boton="true"
        id="listadoPersonas">
        <template v-slot:Estado="{ row }">
          <div class="d-flex justify-content-center align-content-center" id="estadoLaboralPersona">
            <VueToggles height="20" width="50" :value="!!row.Estado" @click="handleEstadoToggle(row)" />
          </div>
        </template>
        <template v-slot:EstadoUsuario="{ row }">
          <div class="d-flex justify-content-center align-content-center" id="estadoSistemaPersona">
            <VueToggles height="20" width="50" :value="!!row.EstadoUsuario" @click="TogglePersonaEstado(row.Id)" />
          </div>
        </template>
        <template v-slot:Detalles="{ row }">
          <b-button v-b-modal.modal-persona @click="infoForPerson(row)" id="detallesPersona">
            <i class="fas fa-eye mx-auto"></i>
          </b-button>
        </template>
        <template v-slot:Id="{ row }">
          <div class="d-flex justify-content-center px-0 mx-0 align-items-center">
            <vs-button v-b-tooltip="{
              title: 'Retiro/Reintegro',
              placement: 'top',
              customClass: 'font_tooltip',
            }" icon danger v-b-modal.modal-retiro-reintegro @click="infoForPerson(row)" id="retiroPersona">
              <i class="fas fa-person-walking-arrow-right"></i>
            </vs-button>
            <!-- <vs-button
              v-b-tooltip="{
                title: 'Retención en la fuente',
                placement: 'top',
                customClass: 'font_tooltip',
              }"
              icon
              color="#0b8f8d"
              @click="retencionEnLaFuenteModal(row)"
            >
              <i class="fas fa-file-invoice-dollar"></i>
            </vs-button> -->
            <vs-button v-b-tooltip="{
              title: `Registro novedades`,
              placement: 'top',
              customClass: 'font_tooltip',
            }" icon color="#6f8ac4" @click="gotoRegistroNovedades(row)" id="novedadPersona">
              <i class="fas fa-question"></i>
            </vs-button>
            <vs-button v-if="isCDCAuditor" danger v-b-tooltip="{
              title: `Cargar soportes CDC`,
              placement: 'top',
              customClass: 'font_tooltip',
            }" icon @click="
              $router.push({
                name: 'AgregarArchivoCuentaCobro',
                params: { id: row.Id },
              })
              ">
              <!-- :to="{ name: 'AgregarArchivoCuentaCobro/' + item.id }" -->
              <i class="fas fa-file-arrow-up"></i>
            </vs-button>
            <vs-button v-b-tooltip="{
              title: `Hoja de vida`,
              placement: 'top',
              customClass: 'font_tooltip',
            }" icon @click="$router.push({ name: 'hoja_vida', params: { id: row.Id } })" id="hvPersona">
              <i class="fas fa-solid fa-file"></i>
            </vs-button>
            <vs-button v-b-tooltip="{
              title: `historia laboral`,
              placement: 'top',
              customClass: 'font_tooltip',
            }" warn icon @click="
              $router.push({
                name: 'Persona_historial_laboral',
                params: { id: row.Id },
              })
              " id="historiaLaboralPersona">
              <i class="fas fa-solid fa-clock"></i>
            </vs-button>
            <vs-button v-b-tooltip="{
              title: `Editar`,
              placement: 'top',
              customClass: 'font_tooltip',
            }" success icon @click="
              $router.push({
                name: 'Persona_editar',
                params: { id: row.Id },
              })
              " id="editarPersona">
              <i class="fas fa-solid fa-pen"></i>
            </vs-button>
            <vs-button v-b-tooltip="{
              title: `Gestionar accesos`,
              placement: 'top',
              customClass: 'font_tooltip',
            }" v-if="persona.rol.nivel === 4 || persona.rol.nivel === 2" icon danger @click="
              $router.push({
                name: 'ControlAccesosPersona',
                params: { PersonaId: row.Id },
              })
              " id="accesosPersona">
              <i class="fas fa-solid fa-lock"></i>
            </vs-button>
          </div>
        </template>
      </DataTableLotes>
    </div>

    <b-modal id="modal-persona" title="Detalles Persona" size="lg" hide-footer>
      <div class="row">
        <div class="col-12">
          <h3>
            <strong> Informacion Personal </strong>
          </h3>
          <div class="d-flex flex-wrap mt-2" style="gap: 1rem">
            <span>
              <strong> Nombre Completo </strong> <br />
              {{ infoForPersonData.nombreCompleto }}
            </span>
            <span>
              <strong>Tipo de Documento</strong> <br />
              {{ infoForPersonData.tipoDoc }}</span>
            <span>
              <strong> Numero de Documento </strong> <br />
              {{ infoForPersonData.doc }}</span>
            <span>
              <strong> Estado Civil </strong> <br />
              {{ infoForPersonData.estadoCivil }}</span>
          </div>
        </div>

        <div class="col-12 mt-2">
          <h3>
            <strong> Contacto </strong>
          </h3>
          <div class="d-flex flex-wrap mt-2" style="gap: 1rem">
            <span>
              <strong> Direccion </strong> <br />
              {{ infoForPersonData.direccion }}</span>
            <span>
              <strong> Municipio </strong> <br />
              {{ infoForPersonData.municipio }}</span>
            <span>
              <strong> Telefono Fijo </strong> <br />
              {{ infoForPersonData.telFijo }}</span>
            <span>
              <strong>Telefono Movil</strong> <br />
              {{ infoForPersonData.telMovil }}</span>
          </div>
        </div>
        <div class="col-12 mt-2">
          <h3><strong>Seguridad</strong></h3>
          <span class="mt-2">
            <strong> Correo </strong> <br />
            {{ infoForPersonData.correo }}</span>
        </div>

        <div class="col-12 mt-2">
          <h3><strong> Empresa </strong></h3>
          <div class="d-flex flex-wrap mt-2" style="gap: 1rem">
            <span><strong> Rol en Empresa </strong> <br />
              {{ infoForPersonData.rol }}</span>
            <span>
              <strong> Empresa </strong> <br />
              {{ infoForPersonData.empresa }}</span>
            <span> <strong> Sucursal </strong> <br />{{ infoForPersonData.sucursal }}</span>
            <span>
              <strong> Area </strong> <br />
              {{ infoForPersonData.area }}</span>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- modal historial -->

    <b-modal id="modal-historial" title="Historial" size="md" hide-footer>
      <div class="bg-dark rounded p-3 mb-2" v-for="h in NPerFechaIngRetHistory" :key="h.id">
        <small class="text-muted text-right d-block">Fecha evento: {{
          $moment(h.fechaEvento).tz("America/Bogota").format("DD-MM-YYYY") }}</small>
        <div class="d-flex align-items-center flex-wrap" style="gap: 1rem">
          <div>
            <small class="text-muted"> Tipo </small>
            <br />
            <b>
              {{ h.tipo }}
            </b>
          </div>

          <div>
            <small class="text-muted"> Fecha </small>
            <br />
            <b>
              {{ $moment(h.fecha).tz("America/Bogota").format("DD-MM-YYYY") }}
            </b>
          </div>

          <div v-if="h.perCausalRetiroId != null">
            <small class="text-muted">Causal</small>
            <br />
            <span>
              -
              <b>
                {{listaCausalRetiro.filter((x) => x.id === h.perCausalRetiroId)[0].causal}}
              </b>
              -
            </span>
          </div>
        </div>
      </div>

      <template v-if="!NPerFechaIngRetHistory.length">
        <p>No hay registros para mostrar</p>
      </template>
    </b-modal>

    <!-- modal retiro / reintegro -->
    <b-modal id="modal-retiro-reintegro" :title="`${infoForPersonData.fechaRetiro == null ? 'Retiro' : 'Reintegro'}`"
      size="md" hide-footer>
      <form ref="formRetiroAndReintegro" @submit.prevent="handleRetiroAndReintegro">
        <!-- historial -->
        <div class="d-flex justify-content-center mb-2">
          <vs-button type="button" icon size="mini" @click="openModalHistorial" success>
            <i class="fas fa-history mr-1"></i>
            Historial
          </vs-button>
        </div>
        <div class="row px-2" v-if="NPerFechaIngRet.id">
          <div class="col-12 bg-dark py-2 rounded"
            v-if="NPerFechaIngRet.tipo === 'Ingreso' || NPerFechaIngRet.tipo === 'Reintegro'">
            <div class="d-flex align-items-center">
              <i class="fas fa-calendar-plus fa-2x"></i>
              <div class="pl-2">
                <span class="text-muted">Fecha contratación</span>
                <br />
                <b>
                  {{ $moment(NPerFechaIngRet.fecha).tz("America/Bogota").format("DD-MM-YYYY") }}
                </b>
              </div>
            </div>
          </div>

          <template v-if="NPerFechaIngRet.tipo === 'Retiro'">
            <div class="col-12 bg-dark py-2 rounded">
              <div class="d-flex align-items-center">
                <i class="fas fa-calendar-times fa-2x"></i>
                <div class="d-flex align-items-center pl-2" style="gap: 1rem">
                  <!-- fecha retiro  -->
                  <div>
                    <span class="text-muted">Fecha retiro</span>
                    <br />
                    <b v-if="infoForPersonData.fechaRetiro != null">
                      {{ $moment(NPerFechaIngRet.fecha).tz("America/Bogota").format("DD-MM-YYYY") }}
                    </b>
                    <b v-else> -- -- -- </b>
                  </div>

                  <!-- causal retiro  -->
                  <div>
                    <span class="text-muted">Causal</span>
                    <br />
                    <span>
                      -
                      <b>
                        {{listaCausalRetiro.filter((x) => x.id === NPerFechaIngRet.perCausalRetiroId)[0].causal}}
                      </b>
                      -
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>

        <!-- MODIFICACIÓN AQUÍ: Cambio en la lógica para mostrar los campos de fecha -->
        <div v-if="infoForPersonData.fechaRetiro == null" class="mt-2">
          <!-- Caso de retiro -->
          <label class="m-0 pl-1 pb-1">Causal de retiro</label>
          <b-form-select required v-model="selected" value-field="id" text-field="causal" :options="listaCausalRetiro">
            <template #first>
              <b-form-select-option selected :value="null" disabled>-- selecciona una causal --</b-form-select-option>
            </template>
          </b-form-select>
          <div class="mb-3 mt-2">
            <label class="form-label">Fecha retiro</label>
            <input required v-model="dataRetiroAndReintegro" type="date" class="form-control" />
          </div>
        </div>
        <div v-else class="mt-2">
          <!-- Caso de reintegro - SIEMPRE mostrar el campo de fecha cuando es reintegro -->
          <div class="mb-3 mt-2">
            <label class="form-label">Fecha reintegro</label>
            <input required v-model="dataRetiroAndReintegro" type="date" class="form-control" />
          </div>
        </div>

        <div class="d-flex justify-content-end mt-3">
          <vs-button type="submit" icon class="px-2" color="#f4c000">
            <i
              :class="`fas fa-person-walking-arrow-${infoForPersonData.fechaRetiro == null ? 'right' : 'loop-left'} mr-1`"></i>
            {{ infoForPersonData.fechaRetiro == null ? "Retirar" : "Reintegrar" }}
          </vs-button>
        </div>
      </form>
    </b-modal>
    <!--retención en la fuente -->
    <!-- <b-modal id="modal-retencion" :title="`Retención en la fuente`" size="md" hide-footer>
      <form ref="fromretencion" @submit.prevent="guardarRetencionEnLaFuente">
        <div class="d-flex justify-content-center mb-2">
          <vs-button type="button" icon size="mini" @click="openModalHistorialRetencion">
            <i class="fas fa-history mr-1"></i>
            Historial
          </vs-button>
        </div>
        <div class="row px-2">
          <div class="col-12 py-2 rounded">
            <div class="row m-3">
              <div class="col-6 px-0">
                <h4 class="mb-2"><b>Mes:</b></h4>
                <b-select v-model="mesSeleccionado" class="form-control personalizado" :options="listaMes" text-field="text" value-field="id" required />
              </div>
              <div class="col-3 px-1">
                <h4 class="mb-2"><b>Año:</b></h4>
                <b-select v-model="anioSeleccionado" class="form-control personalizado" :options="listaAnios" required />
              </div>
              <div class="col-3 px-1">
                <h4 class="mb-2"><b>Articulo:</b></h4>
                <b-select v-model="articuloSeleccionado" class="form-control personalizado" :options="listaArticulos" required />
              </div>
            </div>
            <div class="px-0 mt-3 d-flex justify-content-end">
              <vs-button danger class="px-2 py-1" @click="$bvModal.hide('modal-historialretencion')" id="sendform2"> Cancelar </vs-button>
              <vs-button primary class="px-2 py-1" type="submit" id="sendform3"> Guardar </vs-button>
            </div>
          </div>
        </div>
      </form>
    </b-modal> -->

    <!-- modal historial retención-->
    <!-- <b-modal id="modal-historialretencion" title="Historial retención en la fuente" size="md" hide-footer>
      <template v-if="historialRetencion.length > 0">
        <div class="bg-dark rounded p-3 mb-2" v-for="h in historialRetencion" :key="h.id">
          <div class="d-flex align-items-center flex-wrap" style="gap: 1rem">
            <div class="col-6">
              <small class="text-muted"> Período </small>
              <br />
              <b>
                {{ listaMes[h.mes - 1].text + " - " + h.anio }}
              </b>
            </div>
            <div>
              <small class="text-muted"> Artículo seleccionado</small>
              <br />
              <b>
                {{ h.calculoArt }}
              </b>
            </div>
          </div>
        </div>
      </template>
      <template v-if="!historialRetencion.length">
        <p>No hay registros para mostrar</p>
      </template>
    </b-modal> -->
  </HXContentCard>
</template>
<script>
import DataTableLotes from "@/components/Datatable/DataTableLotes.vue";
import CardTable from "@/components/cardTable/CardTableV2.vue";
import TourGuideLineal from "../../../components/helexium/TourGuideLineal.vue";

const Swal = require("sweetalert2");

export default {
  name: "DataTable",
  components: { CardTable, DataTableLotes, TourGuideLineal },
  data() {
    return {
      dataCards: [
        {
          title: "Todos",
          value: 0,
          iconName: "globe",
          color: "rgba(182,98,255,0.64)",
          tipo: "shield",
          animated: "bounce",
          onActivate: () => {
            this.TipoFiltro = "All";
            this.$refs.dataTableLotes.$emit("actualizar");
          },
        },
        {
          title: "Activos Laborales",
          value: 0,
          iconName: "fa fa-users",
          color: "rgba(21, 128, 61, 1)",
          tipo: "shield",
          animated: "bounce",
          onActivate: () => {
            this.TipoFiltro = "ActivoLaboral";
            this.$refs.dataTableLotes.$emit("actualizar");
          },
        },
        {
          title: "Retirados",
          value: 0,
          iconName: "ban",
          color: "rgba(71,136,255,1)",
          tipo: "shield",
          animated: "bounce",
          onActivate: () => {
            this.TipoFiltro = "Retirados";
            this.$refs.dataTableLotes.$emit("actualizar");
          },
        },
        {
          title: "Con Acceso al sistema",
          value: 0,
          iconName: "fa fa-check-circle",
          color: "rgba(21, 128, 61, 1)",
          tipo: "shield",
          animated: "bounce",
          onActivate: () => {
            this.TipoFiltro = "ConAcceso";
            this.$refs.dataTableLotes.$emit("actualizar");
          },
        },
        {
          title: "Sin Acceso al sistema",
          value: 0,
          iconName: "fa fa-times",
          color: "rgba(71,136,255,1)",
          tipo: "shield",
          animated: "bounce",
          onActivate: () => {
            this.TipoFiltro = "SinAcceso";
            this.$refs.dataTableLotes.$emit("actualizar");
          },
        },
      ],
      activeCard: 0,
      options: [
        { id: 1, value: null, text: "Please select an option" },
        { id: 2, value: "a", text: "This is First option" },
        { id: 3, value: "b", text: "Selected Option" },
        {
          id: 4,
          value: { C: "3PO" },
          text: "This is an option with object value",
        },
        { id: 5, value: "d", text: "This one is disabled", disabled: true },
      ],
      tableName: "Persona",
      listaItems: [],
      persona: {},
      empresaId: "",
      listaPersonaUbicacion: [],
      infoForPersonData: {
        nombreCompleto: null,
        tipoDoc: null,
        doc: null,
        estadoCivil: null,
        direccion: null,
        municipio: null,
        telFijo: null,
        telMovil: null,
        correo: null,
        empresa: null,
        rol: null,
        sucursal: null,
        area: null,
      },
      dataRetiroAndReintegro: null,
      selected: null,
      listaCausalRetiro: [],
      NPerFechaIngRet: {},
      NPerFechaIngRetHistory: [],

      EmpresasLista: [],
      tiposAutenticacion: [{
        id: 1,
        text: "Código de acceso - UTP",
      },
      {
        id: 2,
        text: "Contraseña",
      }
      ],
      EmpresaSeleccionada: null,
      tipoAuthSelected: null,
      TipoFiltro: "All",
      isCDCAuditor: false,
      listaMes: [
        { id: 1, text: "Enero" },
        { id: 2, text: "Febrero" },
        { id: 3, text: "Marzo" },
        { id: 4, text: "Abril" },
        { id: 5, text: "Mayo" },
        { id: 6, text: "Junio" },
        { id: 7, text: "Julio" },
        { id: 8, text: "Agosto" },
        { id: 9, text: "Septiembre" },
        { id: 10, text: "Octubre" },
        { id: 11, text: "Noviembre" },
        { id: 12, text: "Diciembre" },
      ],
      listaAnios: [2025, 2026, 2027],
      listaArticulos: [0, 383, 392],
      mesSeleccionado: new Date().getMonth(),
      anioSeleccionado: new Date().getFullYear(),
      articuloSeleccionado: null,
      personaRetencionEnLaFuente: null,
      historialRetencion: [],
      tourSteps: [
        {
          title: "Estadísticas Personas",
          description:
            "Visualiza un resumen general del personal: total de personas activas, retiradas, con y sin acceso al sistema. Útil para obtener un panorama rápido de la situación laboral.",
          elementId: "estatsPersonas",
        },
        {
          title: "Personas Registradas",
          description:
            "Listado de todas las personas registradas en el sistema. Desde aquí puedes consultar información, acceder a detalles, editar o realizar gestiones individuales.",
          elementId: "listadoPersonas",
        },
        {
          title: "Estado Laboral",
          description:
            "Indica si una persona está activa o inactiva en la empresa. Puedes cambiar su estado laboral según su vinculación actual.",
          elementId: "estadoLaboralPersona",
        },
        {
          title: "Acceso al sistema",
          description:
            "Controla si una persona tiene permisos de ingreso al sistema. Puedes habilitar o deshabilitar su acceso de acuerdo a su rol o situación.",
          elementId: "estadoSistemaPersona",
        },
        {
          title: "Detalles Persona",
          description:
            "Consulta información detallada del perfil de la persona seleccionada, incluyendo datos personales, laborales y de contacto.",
          elementId: "detallesPersona",
        },
        {
          title: "Registrar Retiro/Reintegro",
          description:
            "Registra la salida o el regreso de una persona. Indica la fecha y selecciona la causal correspondiente para mantener el historial actualizado.",
          elementId: "retiroPersona",
        },
        {
          title: "Registrar novedad laboral",
          description:
            "Agrega una novedad laboral, como cambio de cargo, jornada, salario, entre otros. Estas novedades forman parte de la historia laboral.",
          elementId: "novedadPersona",
        },
        {
          title: "Hoja de Vida",
          description:
            "Accede al historial completo del colaborador, incluyendo formación, experiencia, competencias, entre otros aspectos clave de su perfil.",
          elementId: "hvPersona",
        },
        {
          title: "Historia Laboral",
          description:
            "Revisa todas las novedades laborales registradas para la persona. Esta sección ofrece un seguimiento cronológico de su trayectoria en la empresa.",
          elementId: "historiaLaboralPersona",
        },
        {
          title: "Editar Persona",
          description:
            "Modifica los datos registrados de la persona, como nombre, documento, datos de contacto o empresa asociada.",
          elementId: "editarPersona",
        },
        {
          title: "Gestionar Accesos",
          description:
            "Administra los accesos y permisos que tiene la persona dentro del sistema, asignando roles y habilitando funcionalidades según su perfil.",
          elementId: "accesosPersona",
        },
        {
          title: "Agregar Persona",
          description:
            "Desde aquí puedes registrar una nueva persona en el sistema, completando sus datos personales y asignándole un rol inicial.",
          elementId: "agregarPersona",
          redireccionarOtroPasoAPaso: "Persona_agregar",
        },
      ]

    };
  },

  computed: {

    columns() {
      let columnas = []

      columnas.push(
        {
          label: "Numero Documento",
          key: "NumeroDocumento",
          sortable: true,
          width: "100px",
        },
        {
          label: "Nombre",
          key: "NombreCompleto",
          sortable: true,
          width: "300px",
        },
        {
          label: "Contraseña reportes",
          key: "ContrasenaReportes",
          sortable: true,
          width: "100px",
          maxWidth: "100px",
        },
        { label: "Cargo", key: "Cargo", sortable: true, width: "60px" },
        { label: "Sucursal", key: "Sucursal", sortable: true, width: "60px" },
      )

      if (this.persona.rol.nivel == 4 || this.empresaId == '2265B94D-DC65-4ED6-D17A-08DDA2AB239C') {
        columnas.push({
          label: "Marca Nombre", key: "MarcaNombre", sortable: true, width: "60px"
        })
      }



      columnas.push(
        {
          label: "Estado laboral",
          key: "Estado",
          sortable: true,
          width: "100px",
          maxWidth: "100px",
        },
        {
          label: "Acceso Helexium",
          key: "EstadoUsuario",
          sortable: true,
          width: "100px",
          maxWidth: "100px",
        },
        { label: "Detalles", key: "Detalles", sortable: false, width: "60px" },
        {
          label: "Opciones",
          key: "Id",
          sortable: false,
          width: "250px",
          maxWidth: "270px",
        },
      )




      return columnas
    }
  },

  async created() {
    this.persona = JSON.parse(localStorage.getItem("setPersonaAct"));
    this.empresaId = this.persona.empresa.id;
  },
  async mounted() {
    this.$isLoading(true);

    this.getIsCDCAuditor().then((isAuditor) => {
      console.log("isAuditor", isAuditor);
      if (isAuditor) this.isCDCAuditor = true;
    });

    await this.obtenerListaCausalRetiro();
    await this.getData();

    this.$isLoading(false);
  },
  methods: {
    async actualizarTipoAutenticacion() {
      try {
        const res = await this.$store.dispatch("hl_put", {
          path: `Empresa/UpdateTipoAuthEmpresa/${this.EmpresaSeleccionada}/${this.tipoAuthSelected}`,
        });
        // console.log("res", res);
        if (res) {
          Swal.fire("Muy bien!", "Se ha actualizado el tipo de autenticación!", "success");
          this.updateLocalTipoAuthEmpresa();
        }
      } catch (error) {
        console.log("rror ", error);
        Swal.fire("Error!", "Error: " + error, "error");
      }
    },
    updateLocalTipoAuthEmpresa() {
      const empresa = this.EmpresasLista.find((empresa) => empresa.ID === this.EmpresaSeleccionada);
      if (empresa) {
        empresa.TipoAuth = this.tipoAuthSelected;
      }
    },
    async handleCambioEmpresa() {
      this.$refs.dataTableLotes.$emit("actualizar");
      console.log("EmpresaSeleccionada", this.EmpresaSeleccionada);
      if (!this.EmpresaSeleccionada) {
        this.tipoAuthSelected = null;
        return;
      }
      const tipoAuthEmpresaSelected = this.EmpresasLista.find(
        (empresa) => empresa.ID === this.EmpresaSeleccionada
      ).TipoAuth;
      // console.log("tipoAuth", tipoAuthEmpresaSelected);
      this.tipoAuthSelected = tipoAuthEmpresaSelected;
    },
    async handleEstadoToggle(row) {
      // Primero cargamos la información de la persona
      await this.infoForPerson(row);

      // Verificamos el estado actual para determinar si es retiro o reintegro
      if (row.Estado) {
        // Si está activo y se quiere desactivar (retiro)
        this.$bvModal.show("modal-retiro-reintegro");
      } else {
        // Si está inactivo y se quiere activar (reintegro)
        if (this.infoForPersonData.fechaRetiro != null) {
          // Si tiene fecha de retiro, mostramos modal de reintegro
          this.$bvModal.show("modal-retiro-reintegro");
        } else {
          // Si no tiene fecha de retiro, simplemente cambiamos el estado
          this.TogglePersonaEstado(row.Id, true);
        }
      }
    },
    async getIsCDCAuditor() {
      try {
        const response = await this.$store.getters.fetchGet({
          path: `CDC/GetIsCDCAuditor/${this.persona.id}`,
        });
        if (response.ok) {
          const allData = await response.json();
          console.log(allData.data);
          return allData.data;
        }
      } catch (error) {
        console.error("Error en getIsCDCAuditor:", error);
      }
    },
    async guardarRetencionEnLaFuente() {
      try {
        let dataRetencion = {
          PersonaId: this.personaRetencionEnLaFuente,
          Mes: this.mesSeleccionado,
          Anio: this.anioSeleccionado,
          CalculoArt: this.articuloSeleccionado,
        };
        await this.$store.dispatch("hl_post", {
          path: "Persona/CrearPersonaRetencionEnLaFuenteArt",
          data: dataRetencion,
        });
        Swal.fire("Muy bien!", "Datos almacenados correctamente!", "success");
      } catch (error) {
        console.log("rror ", error);
        Swal.fire("Error!", "Error: " + error, "error");
      }
    },
    async openModalHistorialRetencion() {
      let res = await this.$store.dispatch("hl_get", {
        path: "Persona/ListaPersonaRetencionEnLaFuenteArt/" + this.personaRetencionEnLaFuente,
      });
      this.historialRetencion = res;
      this.$bvModal.show("modal-historialretencion");
    },
    async retencionEnLaFuenteModal(item) {
      console.log("row-->", item);
      this.personaRetencionEnLaFuente = item.Id;
      // await this.GetNPerFechaIngRetHistoryByPerson(this.infoForPersonData.personaId);
      // this.$bvModal.show("modal-retencion");
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "Persona/ListaPersonaRetencionEnLaFuenteArt/" + item.Id,
        });
        console.log("res", res);
        if (res && res.data) {
          console.log("ok");
          this.listaRetencionEnLaFuente = res.data;
        } else {
          console.log("no ok");
          this.listaRetencionEnLaFuente = [];
        }
        this.$bvModal.show("modal-retencion");
      } catch (error) {
        this.listaRetencionEnLaFuente = [];
        console.log("err", error);
      }
    },
    async openModalHistorial() {
      await this.GetNPerFechaIngRetHistoryByPerson(this.infoForPersonData.personaId);

      this.$bvModal.show("modal-historial");
    },

    async GetNPerFechaIngRetHistoryByPerson(PersonaId) {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "NPerFechaIngRet/GetNPerFechaIngRetHistoryByPerson/" + PersonaId,
        });
        console.log("res", res);
        if (res && res.data) {
          console.log("ok");
          this.NPerFechaIngRetHistory = res.data;
        } else {
          console.log("no ok");

          this.NPerFechaIngRetHistory = [];
        }

        console.log("this.NPerFechaIngRetHistory", this.NPerFechaIngRetHistory);
      } catch (error) {
        this.NPerFechaIngRetHistory = [];
        console.log("err", error);
      }
    },
    async GetNPerFechaIngRetByPersonaId(PersonaId) {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "NPerFechaIngRet/GetNPerFechaIngRetByPersonaId/" + PersonaId,
        });
        console.log("res", res);
        if (res && res.data) {
          console.log("ok");
          this.NPerFechaIngRet = res.data;
        } else {
          console.log("no ok");

          this.NPerFechaIngRet = {};
        }

        console.log("this.NPerFechaIngRet", this.NPerFechaIngRet);
      } catch (error) {
        this.NPerFechaIngRet = {};
        console.log("err", error);
      }
    },
    async obtenerListaCausalRetiro() {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "PerCausalRetiro/GetPerCausalRetiro",
        });
        console.log("post empresas...", res);
        if (res.length > 0) {
          this.listaCausalRetiro = res;
        } else {
          this.listaCausalRetiro = [];
        }
      } catch (error) {
        this.listaCausalRetiro = [];
        console.log("err", error);
      }
    },
    validarYEnviarFormulario() {
      // Usamos el método nativo reportValidity para validar el formulario
      const form = this.$refs.formRetiroAndReintegro;
      if (form.reportValidity()) {
        // Si el formulario es válido, llamamos a la función de envío
        this.handleRetiroAndReintegro();
      }
    },
    async handleRetiroAndReintegro() {
      try {
        let dataRetiroAndReintegro = {
          FechaEvento: this.$moment(new Date()).tz("America/Bogota").format("YYYY-MM-DDTHH:mm"),
          Fecha: this.$moment(this.dataRetiroAndReintegro).tz("America/Bogota").format("YYYY-MM-DDTHH:mm"),
          PerCausalRetiroId: this.selected,
          PersonaId: this.infoForPersonData.personaId,
          Tipo: this.infoForPersonData.fechaRetiro == null ? "Retiro" : "Reintegro",
        };
        await this.$store.dispatch("hl_post", {
          path: "NPerFechaIngRet/CreateNPerFechaIngRet",
          data: dataRetiroAndReintegro,
        });

        if (this.infoForPersonData.fechaRetiro == null) {
          Swal.fire({
            title: "¿Desea inactivar el acceso al sistema al usuario?",
            text: "¡Puede cambiar el estado las veces que lo requiera!",
            icon: "warning",
            showCancelButton: true,
            cancelButtonColor: "rgb(242, 19, 67)",
            confirmButtonColor: "#1A5CFF",
            cancelButtonText: "¡No, mantener activo!",
            confirmButtonText: "¡Si, inactivar!",
          }).then(async (result) => {
            if (result.isConfirmed) {
              let res = await this.$store.dispatch("hl_get", {
                path: "Persona/TogglePersonaEstadoUsuario/" + this.infoForPersonData.personaId,
              });

              console.log("res", res);

              if (res) {
                Swal.fire("Listo!", "Se ha inactivado el usuario.", "success");
              }
            }
            // Actualizar los datos después de la acción
            await this.getData();
            this.$refs.dataTableLotes.$emit("actualizar");
          });
        } else {
          // Si es reintegro, actualizar los datos después de la acción
          await this.getData();
        }

        this.$toast.success(`${this.infoForPersonData.fechaRetiro == null ? "Se ha retirado la persona con éxito" : "Se reintegro la persona con éxito"}`, {
          position: "top-right",
          timeout: 2984,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: false,
          draggablePercent: 0.41,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        });

        this.$bvModal.hide("modal-retiro-reintegro");
        this.dataRetiroAndReintegro = null;
        this.selected = null;
        this.$refs.dataTableLotes.$emit("actualizar");
      } catch (error) {
        alert(error);
      }
    },
    async TogglePersonaEstado(id, skipConfirmation = false) {
      if (skipConfirmation) {
        await this.$store.dispatch("hl_get", {
          path: "Persona/TogglePersonaEstadoUsuario/" + id,
        });
        await this.getData();
        return;
      }

      Swal.fire({
        title: "¿Seguro que quiere cambiar el estado?",
        text: "¡Puede cambiar el estado las veces que lo requiera!",
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "rgb(242, 19, 67)",
        confirmButtonColor: "#1A5CFF",
        cancelButtonText: "Cancelar",
        confirmButtonText: "¡Si, cambiar!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.$store.dispatch("hl_get", {
            path: "Persona/TogglePersonaEstadoUsuario/" + id,
          });
          await this.getData();

          Swal.fire("Listo!", "Se ha cambiado el estado correctamente.", "success");
          this.$refs.dataTableLotes.$emit("actualizar");
        }
      });

      this.$isLoading(false);
    },
    gotoRegistroNovedades(it) {
      console.log(it);
      if (it.Salario == null || it.Salario == 0) {
        Swal.fire("Error", "Empleado no tiene salario asignado", "Error");
      } else {
        let nominaPath = this.$route.path.includes("nomina");
        if (nominaPath) {
          this.$router.push({
            name: "PersonaNovedades",
            params: { Id: it.Id },
          });
        } else {
          this.$route.params.liquidacionId == undefined
            ? this.$router.push("RegistroNovedades/" + it.Id)
            : this.$router.push("RegistroNovedades/" + it.Id + "/" + this.$route.params.liquidacionId);
        }
      }
    },
    async infoForPerson(data) {
      console.log(data);

      this.infoForPersonData = {};
      this.infoForPersonData.nombreCompleto = data.NombreCompleto;
      this.infoForPersonData.tipoDoc = data.TipoDocumentoDescripcion;
      this.infoForPersonData.doc = data.NumeroDocumento;
      this.infoForPersonData.estadoCivil = data.EstadoCivilDescripcion;
      this.infoForPersonData.direccion = data.Direccion;
      this.infoForPersonData.municipio = data.MunicipioDescripcion;
      this.infoForPersonData.telFijo = data.TelefonoFijo;
      this.infoForPersonData.telMovil = data.TelefonoMovil;
      this.infoForPersonData.correo = data.Correo;
      this.infoForPersonData.rol = data.RolDescripcion;
      this.infoForPersonData.empresa = data.EmpresaNombre;
      this.infoForPersonData.fechaContratacion = data.FechaContratacion;
      this.infoForPersonData.fechaRetiro = data.FechaRetiro;
      this.infoForPersonData.personaId = data.Id;
      this.infoForPersonData.sucursal = data.Sucursal;
      this.infoForPersonData.area = data.Area;

      await this.GetNPerFechaIngRetByPersonaId(data.Id);
    },
    async getPersonaUbicacion() {
      try {
        //   console.log("get empresas...");
        let res = await this.$store.dispatch("hl_get", {
          path: "PersonaUbicacion/List/" + this.empresaId,
        });
        console.log("post empresas...", res);
        if (res.length > 0) {
          this.listaPersonaUbicacion = res;
        } else {
          let nominaPath = this.$route.path.includes("nomina");
          if (nominaPath) {
            this.$router.push({
              name: "PersonaNovedades",
              params: { Id: res.id },
            });
          } else {
            this.$route.params.liquidacionId == undefined
              ? this.$router.push("RegistroNovedades/" + res.id)
              : this.$router.push("RegistroNovedades/" + res.id + "/" + this.$route.params.liquidacionId);
          }
        }
      } catch (error) {
        this.listaPersonaUbicacion = [];
        console.log("err", error);
      }
    },
    obtenerUbicacionPersona(item) {
      let io = this.listaPersonaUbicacion.find((x) => x.persona.id == item.id);
      if (io > 0) {
        let result = this.listaPersonaUbicacion.indexOf(io);
        console.log("cargo ", result);
      }
      return io ? io.cargo.nombre : "";
    },
    getUbicacionPersonaDatallesModal(item) {
      let io = this.listaPersonaUbicacion.find((x) => x.persona.id == item.id);
      // console.log("cargo detalle ", io);
      this.infoForPersonData.sucursal = io.sucursal.descripcion;
      this.infoForPersonData.area = io.area.descripcion;
    },
    async fetchData({ filtro, orden, cantDatos, paginacion }) {
      if (!this.empresaId) {
        console.error("EmpresaId no está definido.");
        return { TotalDatos: 0, data: [] };
      }
      let params = {
        filtro: filtro,
        orden: orden,
        cantDatos: cantDatos,
        paginacion: paginacion,
      };
      let data = [];
      let total = 0;
      if (this.persona.rol.nivel !== 4) this.EmpresaSeleccionada = null;

      await Promise.all([
        this.$store.dispatch("hl_get", {
          path: `Persona/ObtenerCantidadDatos/${this.empresaId}?filtro=${params.filtro}&EmpresaConsultar=${this.EmpresaSeleccionada}&estado=${this.TipoFiltro}`,
        }),
        this.$store.dispatch("hl_post", {
          path: `Persona/ObtenerPersonasLotes/${this.empresaId}?EmpresaConsultar=${this.EmpresaSeleccionada}&estado=${this.TipoFiltro}`,
          data: params,
        }),
        this.$store.dispatch("hl_get", {
          path: `Persona/ObtenerCantidadPersonasEstado/${this.empresaId}?filtro=${params.filtro}&EmpresaConsultar=${this.EmpresaSeleccionada}`,
        }),
      ]).then(([cantidadDatos, Datos, Estados]) => {
        if (cantidadDatos.respuesta) {
          total = cantidadDatos.data;
        }
        if (Datos.respuesta) {
          data = Datos.data;
        }
        if (Estados.respuesta) {
          this.dataCards[0].value = Estados.data.All;
          this.dataCards[1].value = Estados.data.ActivoLaboral;
          this.dataCards[2].value = Estados.data.RetiradoLaboral;
          this.dataCards[3].value = Estados.data.AccesoSistema;
          this.dataCards[4].value = Estados.data.SinAccesoSistema;
        }
      });
      console.log("Esta es la data", data, "Este es el total", total);

      return { total, data };
    },
    async getData() {
      this.$store
        .dispatch("hl_get", {
          path: "Empresa/ListEmpresas",
        })
        .then((response) => {
          if (response.respuesta) {
            console.log("response.data", response.data);

            this.EmpresasLista = response.data;
          }
        });
    },
    startTour() {
      this.$refs.tourGuide.startTour(
        this.tourSteps
      );
    },
  },
};
</script>

<style>
/* tooltip  */
.font_tooltip {
  font-size: 14px;
  font-style: italic;
}
</style>
